export default function isCommentNode(node: Node): node is Comment {
    return node.nodeType === Node.COMMENT_NODE;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect, expectTypeOf } = import.meta.vitest;
    describe('isCommentNode', () => {
        test('results with false for non-comment nodes', () => {
            expect(isCommentNode(document)).toBe(false);
            expect(isCommentNode(document.createProcessingInstruction('target', 'data'))).toBe(false);
            expect(isCommentNode(document.createDocumentFragment())).toBe(false);
            expect(isCommentNode(document.createAttribute('attr'))).toBe(false);
            expect(isCommentNode(document.createTextNode('text'))).toBe(false);
            expect(isCommentNode(document.createElement('a'))).toBe(false);
        });

        test('results with true for comment nodes', () => {
            expect(isCommentNode(document.createComment('comment'))).toBe(true);
        });

        test('justifies type of the given node to match the result of comparison', () => {
            const node: Node = document;

            isCommentNode(node)
                ? expectTypeOf(node).toMatchTypeOf<Comment>()
                : expectTypeOf(node).not.toMatchTypeOf<Comment>();
        });
    });
}

// #endregion
